import { useLanguage } from "@/context/LanguageContext";
import { Reveal, ChapterHeading } from "@/components/Reveal";

const PHOTOS = [
  {
    src: "https://images.pexels.com/photos/28447623/pexels-photo-28447623/free-photo-of-securing-container-latches-on-a-cargo-ship.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Ship Supply Operations",
  },
  {
    src: "https://images.pexels.com/photos/30169171/pexels-photo-30169171/free-photo-of-maritime-worker-in-orange-uniform-on-ship-deck.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Working Gear & PPE",
  },
  {
    src: "https://images.pexels.com/photos/37171408/pexels-photo-37171408/free-photo-of-crew-members-on-a-ship-deck-in-indonesia.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Crew On Deck",
  },
  {
    src: "https://images.pexels.com/photos/16482922/pexels-photo-16482922/free-photo-of-ropes-on-vessel.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Deck Stores & Equipment",
  },
  {
    src: "https://images.pexels.com/photos/35458829/pexels-photo-35458829/free-photo-of-sunset-over-bintulu-port-with-crane-and-cargo-ships.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Port Operations",
  },
  {
    src: "https://images.pexels.com/photos/6585817/pexels-photo-6585817.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Port Logistics",
  },
];

const Gallery = () => {
  const { t } = useLanguage();

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-mist py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-20">
        <ChapterHeading number={t.gallery.number} title={t.gallery.chapter} />

        <div className="mt-12 flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <h2
              data-testid="gallery-title"
              className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl"
            >
              {t.gallery.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p data-testid="gallery-desc" className="max-w-sm text-sm leading-relaxed text-ink/60">
              {t.gallery.desc}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-3">
          {PHOTOS.map((photo, i) => (
            <Reveal key={photo.src} delay={0.06 * i}>
              <figure
                data-testid={`gallery-item-${i}`}
                className="group relative aspect-[4/3] overflow-hidden rounded-xl"
              >
                <img
                  src={photo.src}
                  alt={photo.label}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-navy-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                  aria-hidden="true"
                />
                <figcaption className="absolute bottom-4 left-5 translate-y-2 text-xs font-bold uppercase tracking-[0.15em] text-white opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {photo.label}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
